<div class="service-health service-health--{{ status() }}" data-testid="service-health-row">
  <span class="service-health__dot" data-testid="service-health-dot" aria-hidden="true"></span>
  <span class="sr-only">{{ 'liveDashboard.devops.health.status.' + status() | translate }}</span>
  <div class="service-health__text">
    <div class="service-health__name" data-testid="service-health-name">{{ service().label }}</div>
    <div class="service-health__sub" data-testid="service-health-sub">{{ service().sub }}</div>
  </div>
  <div class="service-health__uptime" data-testid="service-health-uptime">{{ service().uptime }}%</div>
</div>
